import React, { useState } from 'react'
import Input               from '@shared/input'

const ExportDisplay = ({ 
  email, 
  setEmail, 
  count,
  setShowExportDisplay
}) => {
  const [selectedMode, setSelectedMode] = useState(null)

    const onSelect = e => {
    setSelectedMode(e.target.value)
  }

  return(
    <>
      <div className = "form-group">{I18n.t("products.export_results", {count})}</div>
    
      <div className = "radio radio-primary" >
        <input 
          id       = {"visualize_data"}
          name     = "export_mode"
          type     = "radio" 
          value    = {"visualize_data"}
          checked  = {selectedMode === "visualize_data"}
          onChange = {onSelect}
        />
        <label htmlFor={"visualize_data"}>
          {I18n.t(`export.visualize_data`)}
        </label>
      </div>

      <div className = "radio radio-primary" >
        <input 
          id       = {"send_by_email"}
          name     = "export_mode"
          type     = "radio" 
          value    = {"send_by_email"}
          checked  = {selectedMode === "send_by_email"}
          onChange = {onSelect}
        />
        <label htmlFor={"send_by_email"}>
          {I18n.t(`export.send_by_email`)}
        </label>
      </div>
  
      <div className = {`form-group mt-2 ${selectedMode === "send_by_email" ? "" : "d-none"}`}>
        <Input 
          name         = "recipient"
          type         = "email" 
          defaultValue = {email}
          className    = "form-control"
          onChange     = {setEmail}
          label        = {I18n.t("invoices.preferred_email")}
          required
        />
      </div>

      <div className = "modal-buttons">
        <button 
          type      = "button" 
          className = "btn btn-outline-default" 
          onClick   = {() => setShowExportDisplay(false)}
        >
            {I18n.t("button.back")}
        </button>
        <button 
          type      = "submit" 
          className = "btn btn-primary" 
          disabled  = {!selectedMode}
        >
            {I18n.t("button.save")}
        </button>
      </div>
    </>
  )
}

export default ExportDisplay